import { createSelector } from '@reduxjs/toolkit';
import { userSelector } from 'store/selectors/app-selectors';
import type { UserFeatureFlags } from 'core/entities/user/user-feature-flags';

export const allFeatureFlagsSelector = createSelector(userSelector, (user) => {
    return user?.featureFlags ?? ({} as UserFeatureFlags);
});
